// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"g","attrs":{},"children":[{"tag":"path","attrs":{"stroke":"#000","d":"M21 14V21H3L3 14L21 14Z M21 3V10L3 10L3 3L21 3Z M6.5 6.5H6.50391V6.50391H6.5V6.5Z M6.5 17.5H6.50391V17.5039H6.5V17.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]}]},{"tag":"g","attrs":{"id":"server"},"children":[{"tag":"g","attrs":{"id":"fill1","mask":"props.overlapMaskUrl_fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 14V21H3L3 14L21 14Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 3V10L3 10L3 3L21 3Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M21 14V21H3L3 14L21 14Z M21 3V10L3 10L3 3L21 3Z M6.5 6.5H6.50391V6.50391H6.5V6.5Z M6.5 17.5H6.50391V17.5039H6.5V17.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const ServerIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'server',
    ref,
    icon: element,
  },
));

ServerIcon.displayName = 'ServerIcon';

export default ServerIcon;
